import { useState, useEffect, useRef } from 'react'
import { differenceInMilliseconds } from 'date-fns'

const usePeriodicRender = (periodMilliseconds: number) => {
  const [, triggerRender] = useState(0)
  const lastRenderRef = useRef(new Date())

  lastRenderRef.current = new Date()

  useEffect(() => {
    const interval = setInterval(() => {
      if (differenceInMilliseconds(new Date(), lastRenderRef.current) > periodMilliseconds) {
        triggerRender(prev => prev + 1)
      }
    }, 100)

    return () => {
      clearInterval(interval)
    }
  }, [periodMilliseconds])

  return lastRenderRef.current
}

export default usePeriodicRender
